module.exports = __webpack_public_path__ + "static/media/pushBackHome_fromMap.c68c427a.svg";